import { supabase } from '../lib/supabase';

const templateCategoryService = {
  // Convert snake_case to camelCase
  toCamelCase(category) {
    if (!category) return null;
    return {
      id: category?.id,
      categoryValue: category?.category_value,
      categoryLabel: category?.category_label,
      userId: category?.user_id,
      isSystem: category?.is_system,
      createdAt: category?.created_at,
      updatedAt: category?.updated_at
    };
  },

  // Convert camelCase to snake_case
  toSnakeCase(category) {
    return {
      category_value: category?.categoryValue,
      category_label: category?.categoryLabel,
      user_id: category?.userId,
      is_system: category?.isSystem
    };
  },

  // Get all categories
  async getAllCategories() {
    const { data, error } = await supabase?.from('node_categories')?.select('*')?.order('is_system', { ascending: false })?.order('category_label', { ascending: true });

    if (error) throw error;
    return data?.map(this.toCamelCase) || [];
  },

  // Create new category
  async createCategory(categoryData) {
    // Check for duplicate category_value
    const { data: existingCategory } = await supabase
      ?.from('node_categories')
      ?.select('category_value')
      ?.eq('category_value', categoryData?.categoryValue)
      ?.single();

    if (existingCategory) {
      throw new Error(`Category with value "${categoryData?.categoryValue}" already exists`);
    }

    const { data: { user } } = await supabase?.auth?.getUser();
    
    const categoryToInsert = {
      ...this.toSnakeCase(categoryData),
      user_id: user?.id || null,
      is_system: false  // New categories are never system categories
    };

    const { data, error } = await supabase?.from('node_categories')?.insert([categoryToInsert])?.select()?.single();

    if (error) throw error;
    return this.toCamelCase(data);
  },

  // Update category - now works for ALL categories
  async updateCategory(id, categoryData) {
    const categoryToUpdate = this.toSnakeCase(categoryData);

    const { data, error } = await supabase?.from('node_categories')?.update(categoryToUpdate)?.eq('id', id)?.select()?.single();

    if (error) throw error;
    return this.toCamelCase(data);
  },

  // Delete category - now works for ALL categories
  async deleteCategory(id) {
    const { error } = await supabase?.from('node_categories')?.delete()?.eq('id', id);

    if (error) throw error;
  },

  // Delete all custom categories (non-system)
  async deleteAllCustomCategories() {
    const { error } = await supabase
      ?.from('node_categories')
      ?.delete()
      ?.eq('is_system', false);

    if (error) throw error;
  },

  // Get category by ID
  async getCategoryById(id) {
    const { data, error } = await supabase
      ?.from('node_categories')
      ?.select('*')
      ?.eq('id', id)
      ?.single();

    if (error) throw error;
    return this.toCamelCase(data);
  }
};

export default templateCategoryService;